var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isHyperlinkActive === true)?_c('a',{staticClass:"tw-whitespace-nowrap tw-text-primary",attrs:{"href":`tel:${_vm.value}`}},[_vm._v(_vm._s(_vm.labelNationalFormat))]):_c('div',{staticClass:"tw-whitespace-nowrap"},[_vm._v(_vm._s(_vm.labelNationalFormat))])])
}
var staticRenderFns = []

export { render, staticRenderFns }